export const SET_DEPTS = 'Depts/set';
export const SET_DEPTS_TREE = 'Depts/Tree/set';
export const SET_EXPAND_DEPTS = 'Depts/ExpandIDs/set';
export const REMOVE_FROM_EXPAND_DEPTS = 'Depts/ExpandIDs/remove';
export const SET_LATEST_ADDED_DEPT = 'Depts/LatestAdded/set';
export const SET_LATEST_EDITED_DEPT = 'Depts/LatestEdited/set';

export const SET_DEPTS_BIN = 'Depts/Bin/set';

export const SET_DEPTS_UPDATED = 'Depts/UpdateStatus/set';
